import { PublicKey } from '@exodus/solana-web3.js';
export function serializePublicKey(publicKey) {
    return publicKey.toBase58();
}
export function deserializePublicKey(wirePublicKey) {
    return new PublicKey(wirePublicKey);
}
export function condensePublicKey(publicKey) {
    const base58PublicKey = publicKey.toBase58();
    return `${base58PublicKey.slice(0, 4)}..${base58PublicKey.slice(-4)}`;
}
